import { Link } from "react-router-dom";
import { useUtilsStore } from "../../stores/components/utils";
import { useTranslation } from "react-i18next";

interface CardProps {
  title: string;
  icon: string;
  description: string;
  link: string;
}

export function Card({ title, icon, description, link }: CardProps) {
  const { setSearchTerm } = useUtilsStore();
  const { t } = useTranslation();

  return (
    <Link
      to={link}
      aria-label={`Ouvrir ${title}`}
      onClick={() => setSearchTerm("")}
      className="group relative flex flex-col overflow-hidden rounded-2xl border border-slate-200 bg-white p-4 shadow-sm transition-all duration-200 hover:-translate-y-0.5 hover:border-light-red/40 hover:shadow-md hover:shadow-light-red/10 focus-visible:ring-2 focus-visible:ring-light-red/40 focus-visible:outline-none sm:p-5"
    >
      <div className="absolute inset-x-0 top-0 h-1 bg-linear-to-r from-light-red/80 to-light-red/30 opacity-0 transition-opacity duration-200 group-hover:opacity-100" />

      <div className="flex items-center gap-3">
        <span
          aria-hidden="true"
          className="flex size-11 shrink-0 items-center justify-center rounded-xl bg-light-red/10 ring-1 ring-light-red/20 ring-inset transition-colors group-hover:bg-light-red/15 group-hover:ring-light-red/30"
        >
          <img src={icon} alt="" aria-hidden="true" className="size-5.5" />
        </span>
        <h2 className="min-w-0 font-Nunito text-base font-bold text-slate-900">
          {title}
        </h2>
      </div>

      <p className="mt-3 flex-1 font-Nunito text-sm leading-relaxed text-slate-500">
        {description}
      </p>

      <div className="mt-4 flex items-center gap-1.5 border-t border-slate-100 pt-3 font-Nunito text-xs font-bold tracking-wide text-light-red uppercase">
        {t("Voir plus")}
        <svg
          aria-hidden="true"
          className="size-3.5 transition-transform duration-200 group-hover:translate-x-0.5"
          fill="none"
          stroke="currentColor"
          strokeWidth={2.4}
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M13 7l5 5-5 5M6 12h12"
          />
        </svg>
      </div>
    </Link>
  );
}
